import { buildUserSlice } from "data/utils/buildSlice";
import { userRestRequest } from "data/utils/requests";
import { routes } from "data/routes";

import valuesToArray from "functions/valuesToArray";
import { userSliceData } from "../../utils/thunks";

const key = "enrollmentResources";
export const slice = buildUserSlice(key);
export const { reducer: enrollmentResources } = slice;
export const actions = slice.actions;

export const fetchEnrollmentResources = (uid) => {
  return async (dispatch, getState) => {
    const state = getState();
    const slice = userSliceData({ state, key, uid });

    if (["success", "failure", "pending"].includes(slice.loadState)) {
      return new Promise((resolve, _reject) => resolve(slice));
    }

    dispatch(actions.start(uid));
    userRestRequest({ url: routes[key] })({
      dispatch,
      actions,
      uid,
      dataHandler: ({ links = {} }) => {
        dispatch({
          type: "SET_API_LINKS",
          value: valuesToArray(links),
        });
      },
    });
  };
};
